/*!
 * Smooth scrolling plugin. | v2.0.0
 * Author: Zachary Miller
 */
function SmoothScroll(l,o){let t=this;t.root=$("html, body"),t.allow_url_change="object"!=typeof o||!o.hasOwnProperty("allow_url_change")||o.allow_url_change,t.scroll_offset_modifier="object"==typeof o&&o.hasOwnProperty("scroll_offset_modifier")?o.scroll_offset_modifier:null,t.scroll_time="object"==typeof o&&o.hasOwnProperty("scroll_time")?o.scroll_time:null,t.callback="object"==typeof o&&o.hasOwnProperty("callback")?o.callback:null,t.scroll=function(l,o,e,r){let c=$(l),a="function"!=typeof t.scroll_offset_modifier?0:t.scroll_offset_modifier();o=null==o?c.offset().top-a:o-a,e=null==e?500:e,r="function"!=typeof r?function(){}:r,t.root.animate({scrollTop:o},e,null,r())},null!=l&&$(document).ready(function(){window.location.hash&&$(window.location.hash).length&&t.scroll(window.location.hash,null,null,t.callback),$(l).click(function(l){let o=$(this),e=o.attr("data-smoothscroll-target")?o.data("smoothscroll-target"):o.attr("href"),r=$(e);if(r.length>0){let l=o.attr("data-smoothscroll-offset-top")?r.offset().top-parseInt(o.data("smoothscroll-offset-top")):null,c=o.attr("data-smoothscroll-scroll-time")?parseInt(o.data("smoothscroll-scroll-time")):null;if(t.scroll(e,l,c),!t.allow_url_change)return!1}})})}


const animateCSS = (element, animation, prefix = 'animate__') => new Promise((resolve, reject) => {
	const animationName = `${prefix}${animation}`;
	const node = document.querySelector(element);

	node.classList.add(`${prefix}animated`, animationName);

	// When the animation ends, we clean the classes and resolve the Promise
	function handleAnimationEnd(event) {
		event.stopPropagation();
		node.classList.remove(`${prefix}animated`, animationName);
		resolve('Animation ended');
	}

	node.addEventListener('animationend', handleAnimationEnd, {once: true});
});


function cartUpdateEvents(cart) {
	if (typeof updateNavbarCart == 'function') {
		updateNavbarCart(cart);
	}

	if (typeof cartCheckoutNowButton == 'function') {
		cartCheckoutNowButton(cart);
	}
}


$(document).ready(function() {
	$('a[href="#!"]').click(function(e) {
		e.preventDefault ? e.preventDefault() : e.returnValue = false;
	});
	window.smooth_scroll = new SmoothScroll('.anchor-link, .site-link[href^="#"][href!="#!"], .site-link[data-smoothscroll-target^="#"][data-smoothscroll-target!="#!"]', {
		scroll_offset_modifier: function() {
			return $('#shopify-section-header').height();
		},
		callback: function() {
			// console.log('SCROLLED');
		}
	});
});



